module.exports = __webpack_public_path__ + "img/Frame29.13030c91.png";